<template>
  <div class="disease-trend-chart">
    <!-- 标题栏 -->
    <Title type="特殊" title="贴敷复诊率" @setting-click="handleSetting" />

    <!-- 图表区域 -->
    <div class="chart-container">
      <div id="diseaseTrendChart" class="trend-chart"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import resize from "@/components/Charts/mixins/resize";
import Title from "../title.vue";

export default {
  name: 'DiseaseTrendChart',
  mixins: [resize],
  components: {
    Title
  },
  data() {
    return {
      chart: null,
      // 示例数据
      dates: ['2025年05月', '2025年06月', '2025年07月', '2025年08月', '2025年09月', '2025年10月'],
      diseaseData: {
        '上呼吸道感染': [25000, 45000, 70000, 100000, 110000, 8000],
        '支气管炎': [45000, 70000, 120000, 180000, 190000, 15000],
        '咳嗽': [75000, 120000, 180000, 250000, 260000, 25000]
      }
    }
  },
  mounted() {
    this.initChart()
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    initChart() {
      this.$nextTick(() => {
        const chartDom = document.getElementById('diseaseTrendChart')
        if (!chartDom) return
        
        this.chart = echarts.init(chartDom, 'dark')
        
        const option = {
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            borderColor: '#74ffbe',
            borderWidth: 1,
            textStyle: {
              color: '#fff',
              fontSize: 12
            }
          },
          legend: {
            data: ['上呼吸道感染', '支气管炎', '咳嗽'],
            top: 10,
            right: 20,
            textStyle: {
              color: '#74ffbe',
              fontSize: 12
            },
            itemGap: 20,
            icon: 'circle'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.dates,
            axisLine: {
              lineStyle: {
                color: '#74ffbe'
              }
            },
            axisLabel: {
              color: '#74ffbe',
              fontSize: 11
            }
          },
          yAxis: {
            type: 'value',
            min: 0,
            max: 300000,
            interval: 50000,
            axisLine: {
              lineStyle: {
                color: '#74ffbe'
              }
            },
            axisLabel: {
              color: '#74ffbe',
              fontSize: 11,
              formatter: function(value) {
                return value / 1000 + 'k'
              }
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(116, 255, 190, 0.1)',
                type: 'dashed'
              }
            }
          },
          series: [
            {
              name: '上呼吸道感染',
              type: 'line',
              smooth: true,
              data: this.diseaseData['上呼吸道感染'],
              itemStyle: {
                color: '#91cc75'
              },
              lineStyle: {
                color: '#91cc75',
                width: 2
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgba(145, 204, 117, 0.3)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(145, 204, 117, 0)'
                  }
                ])
              }
            },
            {
              name: '支气管炎',
              type: 'line',
              smooth: true,
              data: this.diseaseData['支气管炎'],
              itemStyle: {
                color: '#73c0de'
              },
              lineStyle: {
                color: '#73c0de',
                width: 2
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgba(115, 192, 222, 0.3)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(115, 192, 222, 0)'
                  }
                ])
              }
            },
            {
              name: '咳嗽',
              type: 'line',
              smooth: true,
              data: this.diseaseData['咳嗽'],
              itemStyle: {
                color: '#fac858'
              },
              lineStyle: {
                color: '#fac858',
                width: 2
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgba(250, 200, 88, 0.3)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(250, 200, 88, 0)'
                  }
                ])
              }
            }
          ]
        }
        
        this.chart.setOption(option)
        
        // 响应式调整
        window.addEventListener('resize', () => {
          if (this.chart) {
            this.chart.resize()
          }
        })
      })
    },
    showSettings() {
      // 显示设置对话框
      console.log('显示设置')
    }
  }
}
</script>

<style lang="scss" scoped>
.disease-trend-chart {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #fff;

  .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    margin-bottom: 10px;
    flex-shrink: 0;

    .header-left {
      display: flex;
      align-items: center;
      gap: 8px;

      .header-icon {
        color: #74ffbe;
        font-size: 16px;
      }

      .header-title {
        color: #74ffbe;
        font-size: 14px;
        font-weight: 600;
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 12px;

      .top3-btn {
        background-color: #60fcb2;
        color: #0d1014;
        padding: 4px 12px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
      }

      .header-setting {
        color: #74ffbe;
        font-size: 16px;
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: #60fcb2;
        }
      }
    }
  }

  .chart-container {
    flex: 1;
    min-height: 0;
    width: 100%;

    #diseaseTrendChart {
      width: 100%;
      height: 100%;
      min-height: 200px;
    }
  }
}
</style>

